import React from 'react';

/**
 * Collapsible 300px context panel on the right. Parent supplies content;
 * this component handles the collapse toggle and header slot. Hidden below
 * 1100px via CSS (see .ws-shell media queries in index.css).
 */
export default function RightPanel({ open, onToggle, children, title = 'Activity', fixed = false }) {
  return (
    <aside className={`ws-right${open ? '' : ' ws-right-collapsed'}${fixed ? ' ws-right--fixed' : ''}`} aria-hidden={!open}>
      {/* Fixed (Home) panels carry their own section headings ("Opportunities
          for you", "Recent activity") — no separate title bar on top. */}
      {!fixed && (
        <div className="ws-right-head">
          <div className="ws-right-title">{title}</div>
          <button className="ws-right-toggle" onClick={onToggle} aria-label={open ? 'Collapse panel' : 'Expand panel'}>
            {open ? '›' : '‹'}
          </button>
        </div>
      )}
      <div className="ws-right-body">
        {children || (
          <div className="ws-right-empty">
            <div className="ws-right-empty-title">Nothing here yet</div>
            <div className="ws-right-empty-sub">Your recent activity will appear here as you build episodes.</div>
          </div>
        )}
      </div>
    </aside>
  );
}
